import React, { ReactNode } from "react";
import styled, { useTheme } from "styled-components";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens.ts";

interface ChartEmptyProps {
  height: number;
  children: ReactNode;
}

// The message sits in the gap between the middle two.
const GUIDES = ["14%", "38%", "62%", "86%"];

/**
 * A chart with nothing to plot: the chart's own dotted guides with the
 * message between them, open on the panel rather than boxed into a well.
 */
const ChartEmpty = ({ height, children }: ChartEmptyProps) => {
  const tokens = getNewLookTokens(useTheme());
  return (
    <Wrapper style={{ height }}>
      <Guides width="100%" height="100%" aria-hidden={true}>
        {GUIDES.map((y) => (
          <line
            key={y}
            x1={0}
            x2="100%"
            y1={y}
            y2={y}
            stroke={tokens.hairlineStrong}
            strokeDasharray="2 4"
          />
        ))}
      </Guides>
      <Message>{children}</Message>
    </Wrapper>
  );
};

export default ChartEmpty;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
`;
const Guides = styled.svg`
  position: absolute;
  inset: 0;
`;
const Message = styled.span`
  position: relative;
  ${newLookType.meta};
  color: ${(p) => getNewLookTokens(p.theme).muted};
  text-align: center;
`;
